(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('contact-nl-form');
  if (!form) return;
  form.addEventListener('submit', function () {
    var checkbox = document.getElementById('contact-nl-news');
    if (!checkbox || !checkbox.checked) return;
    var emailEl = document.getElementById('contact-nl-email');
    if (!emailEl || !emailEl.value) return;
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', emailEl.value);
    fd.append('contact[tags]', 'newsletter,contact_form_checkbox');
    fd.append('contact[accepts_marketing]', 'true');
    fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["france-carte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-france-carte]');
    if (!root) return;
    var zones = root.querySelectorAll('.fc-zone');
    var rows  = root.querySelectorAll('[data-jump]');
    var rest  = root.querySelector('[data-fc-rest]');
    var act   = root.querySelector('[data-fc-active]');
    var elName = root.querySelector('[data-fc-name]');
    var elStat = root.querySelector('[data-fc-status]');
    var elPhr  = root.querySelector('[data-fc-phrase]');
    var elDet  = root.querySelector('[data-fc-details]');
    var activeSlug = null;

    function showRest() {
      if (rest) rest.hidden = false;
      if (act) act.hidden = true;
    }
    function fill(g) {
      var soon = g.getAttribute('data-state') === 'soon';
      elName.textContent = g.getAttribute('data-name');
      elStat.textContent = soon
        ? g.getAttribute('data-month')
        : g.getAttribute('data-status') + ' · ' + g.getAttribute('data-month');
      elPhr.textContent = g.getAttribute('data-phrase');
      elDet.innerHTML = '';
      (g.getAttribute('data-keywords') || '').split(' · ').forEach(function (v) {
        v = v.trim(); if (!v) return;
        var li = document.createElement('li'); li.textContent = v; elDet.appendChild(li);
      });
      act.setAttribute('data-state', g.getAttribute('data-state'));
      if (rest) rest.hidden = true;
      act.hidden = false;
    }
    function setActive(slug) {
      activeSlug = slug;
      zones.forEach(function (z) { z.classList.toggle('is-active', z.getAttribute('data-region') === slug); });
      var g = root.querySelector('.fc-zone[data-region="' + slug + '"]');
      if (g) fill(g);
    }

    zones.forEach(function (g) {
      g.addEventListener('mouseenter', function () { fill(g); });
      g.addEventListener('mouseleave', function () {
        if (activeSlug) setActive(activeSlug); else showRest();
      });
      g.addEventListener('focus', function () { fill(g); });
      g.addEventListener('blur', function () {
        if (activeSlug) setActive(activeSlug); else showRest();
      });
      g.addEventListener('click', function () { setActive(g.getAttribute('data-region')); });
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); setActive(g.getAttribute('data-region')); }
      });
    });

    rows.forEach(function (b) {
      b.addEventListener('click', function () {
        var slug = b.getAttribute('data-jump');
        setActive(slug);
        if (window.matchMedia('(max-width: 899px)').matches && act) {
          act.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    showRest();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.mb-header');
    if (!header) return;
    function publish() {
      document.documentElement.style.setProperty(
        '--header-h', Math.round(header.getBoundingClientRect().height) + 'px');
    }
    publish();
    window.addEventListener('resize', publish);
    window.addEventListener('load', publish);
    if ('ResizeObserver' in window) new ResizeObserver(publish).observe(header);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-journey-h]');
    if (!section) return;
    var track   = section.querySelector('[data-journey-track]');
    var slides  = section.querySelectorAll('[data-journey-slide]');
    var indexEl = section.querySelector('[data-journey-index]');
    var fillEl  = section.querySelector('[data-journey-fill]');
    var hintEl  = section.querySelector('[data-journey-hint]');
    var prevBtn = section.querySelector('[data-journey-prev]');
    var nextBtn = section.querySelector('[data-journey-next]');
    if (!track || !slides.length) return;

    var count = slides.length;
    var mq = window.matchMedia('(min-width: 768px)');
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Mode épinglé (desktop / tablette, mouvement autorisé) : le viewport est figé
    // par `position: sticky` (CSS) et la piste se translate selon la POSITION de
    // scroll. Aucune capture de molette, aucun gel de Lenis → arrivée et sortie
    // naturelles, défilement fluide, pas de coup sec ni de blocage.
    // Sinon (mobile ≤767 / reduced-motion) : scroll horizontal natif ou empilement.
    function pinned() { return mq.matches && !rm.matches; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

    var lastIdx = -1;
    var ticking = false;

    function setActive(idx) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === idx);
      }
    }

    // Active/désactive les flèches en bout de course (accessibilité + clarté).
    function updateArrows(idx) {
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= count - 1;
    }

    // Index de la région actuellement à l'écran (selon le mode).
    function currentIndex() {
      if (pinned()) {
        var rect = section.getBoundingClientRect();
        var scrollable = section.offsetHeight - window.innerHeight;
        var p = scrollable > 0 ? clamp(-rect.top / scrollable, 0, 1) : 0;
        return Math.round(p * (count - 1));
      }
      var sw = slides[0].getBoundingClientRect().width || 1;
      return clamp(Math.round(track.scrollLeft / sw), 0, count - 1);
    }

    // Navigation par flèche : avance/recule d'une région.
    function navigate(dir) {
      var idx = clamp(currentIndex() + dir, 0, count - 1);
      if (pinned()) {
        var rect = section.getBoundingClientRect();
        var scrollable = section.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        restIdx = idx;
        var target = (rect.top + window.pageYOffset) + (idx / (count - 1)) * scrollable;
        var lenis = window.__mbLenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
          lenis.scrollTo(target, { duration: 0.7 });
        } else {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      } else {
        var sw = slides[0].getBoundingClientRect().width || 1;
        track.scrollTo({ left: idx * sw, behavior: 'smooth' });
        if (hintEl) hintEl.classList.add('is-hidden');
      }
      updateArrows(idx);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { navigate(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { navigate(1); });

    function render() {
      if (!pinned()) return;
      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      var p = scrollable > 0 ? clamp(-rect.top / scrollable, 0, 1) : 0;
      track.style.transform = 'translate3d(' + (-p * (count - 1) * 100) + 'vw, 0, 0)';
      if (fillEl) fillEl.style.width = (p * 100) + '%';
      var idx = Math.round(p * (count - 1));
      if (idx !== lastIdx) {
        lastIdx = idx;
        if (indexEl) indexEl.textContent = pad(idx + 1);
        setActive(idx);
        updateArrows(idx);
      }
    }

    // ---- Snap « à l'arrêt » (desktop épinglé uniquement) -------------------
    // Le scroll fait glisser la piste en continu ; sans règle, on peut
    // s'immobiliser entre deux régions. On recale sur la région la plus proche,
    // une à une, MAIS seulement quand le mouvement est réellement terminé  
    // sinon on lutterait contre l'inertie de Lenis (sensation de bug).
    // Garde-fous contre ce combat :
    //   • on ne snape que si la vitesse de scroll est ~nulle (mesurée frame/frame) ;
    //   • tout nouveau geste utilisateur (molette / trackpad / clavier) ANNULE
    //     immédiatement un recalage en cours → la molette n'est jamais capturée ;
    //   • un garde-fou (timeout) remet toujours l'état à zéro.
    // On ne snape qu'à l'INTÉRIEUR de la galerie épinglée (arrivée/sortie
    // naturelles) et jamais pendant une nav par ancre (window.__mbAnchorNav).
    var SNAP_IDLE = 160;  // ms sans geste utilisateur avant d'autoriser le calage
    var SNAP_VMAX = 1.5;  // px/frame : au-dessus, ça bouge encore → on attend
    var SNAP_MIN  = 6;    // px : en deçà, on est déjà calé
    var SNAP_STEP = 0.14; // fraction de région à dépasser pour valider la suivante
    var restIdx   = 0;    // région sur laquelle on était posé (pour le sens du calage)
    var lastInput  = 0;
    var lastY      = window.pageYOffset;
    var velY       = 0;
    var snapping   = false;
    var snapSafety = null;
    var settleTimer = null;

    function nowMs() { return Date.now(); }

    function endSnap() {
      snapping = false;
      if (snapSafety) { window.clearTimeout(snapSafety); snapSafety = null; }
    }

    // Recale restIdx sur la région réellement à l'écran (refresh / resize).
    function syncRest() {
      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      if (scrollable <= 0) { restIdx = 0; return; }
      restIdx = clamp(Math.round(clamp(-rect.top / scrollable, 0, 1) * (count - 1)), 0, count - 1);
    }

    // Un geste de l'utilisateur reprend toujours la main sur un snap en cours.
    function onUserInput() {
      lastInput = nowMs();
      if (snapping) endSnap();
    }
    ['wheel', 'touchstart', 'touchmove', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, onUserInput, { passive: true });
    });

    function maybeSnap() {
      if (!pinned() || snapping || count < 2) return;
      if (window.__mbAnchorNav) return;                 // nav par ancre en cours
      if (nowMs() - lastInput < SNAP_IDLE) return;      // l'utilisateur agit encore
      if (Math.abs(velY) > SNAP_VMAX) return;           // ça glisse encore (Lenis)
      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;
      // Hors galerie épinglée (en approche ou déjà dépassée) : on ne touche à rien.
      if (rect.top > 0 || -rect.top > scrollable) return;
      var p = clamp(-rect.top / scrollable, 0, 1);
      var stepPos = p * (count - 1);     // position continue (ex. 3.2 = région 3 + 0.2)
      var idx;
      // À moins d'une région d'écart : on VALIDE dans le sens du geste dès qu'on
      // a dépassé un petit seuil → un coup de molette fait avancer d'une région
      // (au lieu de revenir en arrière, ce qui donnait l'impression de blocage).
      // Au-delà d'une région d'écart (gros scroll) : on cale sur la plus proche.
      if (Math.abs(stepPos - restIdx) <= 1) {
        if (stepPos > restIdx + SNAP_STEP) idx = restIdx + 1;
        else if (stepPos < restIdx - SNAP_STEP) idx = restIdx - 1;
        else idx = restIdx;
      } else {
        idx = Math.round(stepPos);
      }
      idx = clamp(idx, 0, count - 1);
      var target = (rect.top + window.pageYOffset) + (idx / (count - 1)) * scrollable;
      if (Math.abs(target - window.pageYOffset) < SNAP_MIN) { restIdx = idx; return; } // déjà calé
      restIdx = idx;
      snapping = true;
      snapSafety = window.setTimeout(function () { endSnap(); render(); }, 1100);
      var release = function () { endSnap(); render(); };
      var lenis = window.__mbLenis;
      if (lenis && typeof lenis.scrollTo === 'function') {
        // Recalage plus long + easing doux (ease-in-out) → glissement velouté
        // jusqu'à la région, sans départ ni arrêt secs.
        lenis.scrollTo(target, {
          duration: 0.72,
          easing: function (t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          },
          onComplete: release
        });
      } else {
        window.scrollTo({ top: target, behavior: 'smooth' });
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset;
        velY = y - lastY;
        lastY = y;
        render();
        maybeSnap();
      });
      // Filet : quand les événements de scroll cessent complètement, on
      // considère le mouvement terminé (velY = 0) et on retente une fois.
      if (settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        velY = 0;
        maybeSnap();
      }, SNAP_IDLE + 40);
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    function onResize() {
      endSnap();
      if (settleTimer) { window.clearTimeout(settleTimer); settleTimer = null; }
      lastY = window.pageYOffset;
      velY = 0;
      if (!pinned()) { track.style.transform = ''; }
      lastIdx = -1;
      syncRest();
      render();
    }
    window.addEventListener('resize', onResize, { passive: true });
    if (mq.addEventListener) {
      mq.addEventListener('change', onResize);
      rm.addEventListener('change', onResize);
    }

    // Indicateur mobile : progression depuis le scroll horizontal natif + masquage du hint.
    track.addEventListener('scroll', function () {
      if (pinned()) return;
      window.requestAnimationFrame(function () {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        var idx = Math.round(p * (count - 1));
        if (indexEl) indexEl.textContent = pad(idx + 1);
        if (fillEl) fillEl.style.width = (p * 100) + '%';
        if (hintEl && track.scrollLeft > 8) hintEl.classList.add('is-hidden');
        updateArrows(idx);
      });
    }, { passive: true });

    // État initial + recalage après chargement complet (hauteurs définitives).
    if (pinned()) { syncRest(); render(); } else { setActive(0); updateArrows(0); }
    window.addEventListener('load', function () { lastIdx = -1; syncRest(); render(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
